<div class="govuk-width-container">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
      <p class="govuk-body">
        You can translate this site into 60 different languages using Google Translate.
      </p>
      <p class="govuk-body">
        Please note that {{meta.teamName}} is not responsible for the content or accuracy of the translation.
      </p>
    </div>
  </div>

  <div class="govuk-grid-row">
    <div class="govuk-grid-column-one-third" *ngFor="let group of groups">
        <div *ngFor="let item of group" class="govuk-!-margin-top-3">
          <a class="govuk-link" [href]="item.href">{{item.englishName}} ({{item.name}})</a>
        </div>
    </div>
  </div>
</div>
